import React from 'react';
import { t } from '../../i18n';
import {
  CardWrapper,
  useStyles,
  CardTitle,
  TextCenter,
  CenterRow,
  ButtonBackWrapper
} from './SuccessScreen.style';
import { CardContent } from '@material-ui/core';
import PrimaryButton from '../PrimaryButton/PrimaryButton.component';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

interface SuccessScreenProps {
  handleGoBack: any;
  titleMessage: string;
  descriptionMessage: string;
  buttonBackMessage: string;
  isShowSuccessIcon?: boolean;
  isShowReturnIcon?: boolean;
}

const SuccessScreen: React.FC<SuccessScreenProps> = (props) => {
  const {
    handleGoBack,
    titleMessage,
    descriptionMessage,
    buttonBackMessage,
    isShowSuccessIcon,
    isShowReturnIcon
  } = props;
  const classes = useStyles();

  return (
    <CardWrapper>
      <CardContent className={classes.successScreenContent}>
        {!!isShowSuccessIcon && (
          <CheckCircleOutlineIcon
            style={{
              color: '#86C36F',
              fontSize: '72px',
              width: '100%',
              marginBottom: '15px'
            }}
          />
        )}
        <CardTitle>{titleMessage}</CardTitle>
        <TextCenter className={`${classes.mb30}`}>
          {descriptionMessage}
        </TextCenter>
        <CenterRow>
          <ButtonBackWrapper>
            <PrimaryButton
              onClick={handleGoBack}
              variant="contained"
              title={buttonBackMessage}
              isShowIcon={!!isShowReturnIcon}
              titleClassName="patient-document"
              style={{
                width: '150px',
                margin: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            />
          </ButtonBackWrapper>
        </CenterRow>
      </CardContent>
    </CardWrapper>
  );
};

export default SuccessScreen;
